module.exports = __webpack_public_path__ + "static/scale-model-of-pixar-pier-in-garden-grove-california-dd82356c92f6f462d074dce71fc1d552.png";